export { ChatRoomModel };
/**
 * Модель диалога "Чатрум" на странице "Консультации".
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class ChatRoomModel {
  /**
   * Заголовок диалога.
   * @type {string}
   */
  title = "Чатрум";
  /**
   * Список сообщений.
   * @type {Array.<ChatRoomModel~Message>}
   */
  messages = [];
  /**
   * Переменные окружения, подставляемые в каждый запрос.
   * @type {Object}
   */
  env = {};
  /**
   * Закрывает диалог.
   * @param {Event | Object} event - Событие.
   */
  onClose = (event) => {};
  /**
   * Отправляет запрос на добавление сообщения в чатрум.
   * @param {Object} data - Данные формы.
   */
  onSubmit = (data) => {};
  /**
   * @returns {Request} Запрос на загрузку сообщений.
   */
  getRequest = () => ({
    method: "post",
    path: "/student/question_tutor/messages",
    data: {
      ...this.env,
    },
  });
  /**
   * @returns {Request} Запрос на добавление сообщения в чатрум.
   * @param {Object} data - Данные формы.
   */
  getSubmitRequest = (data) => ({
    method: "post",
    path: "/student/question_tutor/add",
    data: {
      ...this.env,
      ...data,
    },
  });
  /**
   * @returns {SchemaJSON} Схема формы для диалога добавления сообщения.
   */
  getSchema = () => ({
    properties: {
      text: {
        title: "Задать уточняющий вопрос",
        type: "string",
        rows: 7,
      },
      attachments: {
        title: "Вложения",
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["text"],
    actions: [
      {
        name: "Отправить",
        type: "primary",
      },
      {
        name: "Отмена",
        onClick: this.onClose,
      },
    ],
    onSubmit: this.onSubmit,
  });
  /**
   * Разбор ответа от сервера.
   * @param {Object} response - Ответ от сервера.
   */
  parseResponse(response) {
    this.messages = response;
  }
  /**
   * Копирует свойства объекта.
   * @param {BringFriendModel} props - Свойства объекта.
   */
  constructor(props) {
    Object.assign(this, props);
  }
}
